export default __webpack_public_path__ + "static/media/OSCOHT-LOGO.9a1f8788.jpg";